/**
 * ══════════════════════════════════════════════════════════════════════════════════════
 * B-1 — EL ERROR DE AXIOS TRADUCIDO AL MOTIVO QUE SE MUESTRA. PURO, SIN JSX.
 * ══════════════════════════════════════════════════════════════════════════════════════
 *
 * ⚠ Vive aparte del componente **para que se pueda medir sin montar nada**: Node no importa
 * `.jsx`, así que la lógica dentro del componente habría quedado fuera del alcance del guardián
 * y probada solo a ojo. Mismo patrón que `formatProject.js` y `formatGl.js`.
 */

/**
 * Los mensajes que la API usa para hablarle a una MÁQUINA, no a una persona. No se muestran.
 *
 * ⚠ No es una heurística de "¿esto parece inglés?": es la lista corta y explícita de las cadenas
 * internas que devuelve el backend. De las cuatro llamadas de carga que usan estas pantallas,
 * **la única alcanzable era `'Not found'`** (`receiptController.js`, la carrera entre el gate de
 * alcance y la fila) y esta pieza la traduce en su origen. Esto queda como red, no como muleta:
 * un 500 inesperado no puede poner inglés en pantalla.
 */
const MENSAJES_INTERNOS = new Set([
  'Not found', 'Forbidden', 'Unauthorized', 'Internal server error', 'Invalid or expired token',
]);

/** El respaldo en español, por código, cuando el backend no dejó un mensaje utilizable. */
const RESPALDO = {
  401: 'Su sesión expiró. Vuelva a iniciar sesión.',
  403: 'No tiene acceso a este registro.',
  404: 'Este registro no existe o ya fue eliminado.',
  500: 'Hubo un error al cargar. Intente de nuevo en unos minutos.',
};

/**
 * Traduce el error de axios al motivo que se muestra. **Puro**: se prueba sin montar nada.
 *
 * @returns {{codigo: number|null, mensaje: string, tipo: 'permiso'|'ausente'|'conexion'|'error'}}
 */
export function motivoDeCarga(err) {
  const codigo = err?.response?.status ?? null;

  // Sin respuesta: el servidor no contestó. Decirlo así y no "no encontrado", que sería mentir.
  if (codigo === null) {
    return {
      codigo: null,
      tipo: 'conexion',
      mensaje: 'No se pudo conectar con el servidor. Revise su conexión e intente de nuevo.',
    };
  }

  const delBackend = err?.response?.data?.error;
  const usable = typeof delBackend === 'string'
    && delBackend.trim() !== ''
    && !MENSAJES_INTERNOS.has(delBackend.trim());

  const tipo = codigo === 403 || codigo === 401 ? 'permiso'
    : codigo === 404 ? 'ausente'
    : 'error';

  return {
    codigo,
    tipo,
    mensaje: usable ? delBackend.trim() : (RESPALDO[codigo] || RESPALDO[500]),
  };
}

